<template>
    <div class="p-4">
        <div class="view-probe-table-header p-2">
            <h2 class="main-title">{{ tableTitle }}</h2>
        </div>
        <div :class="[isPassed ? 'bg-color-green' : 'bg-color-red']" class="view-probe-table-header p-2">
            <v-icon color="#fff" left>{{
                isPassed ? 'mdi-checkbox-marked-circle-outline' : 'mdi-alert-octagon-outline'
            }}</v-icon
            >{{ tableSubTitle }}
        </div>
        <v-data-table
            :items-per-page="-1"
            :hide-default-footer="true"
            :headers="headers"
            :items="items"
            :item-class="itemRowBackground"
        >
            <template #[`item.control`]="{ item }">
                {{ item.control && !item.max ? item.control : `[${item.min}, ${item.max}]` }}
            </template>
            <template #[`item.tolerance`]="{ item }">
                {{ item.tolerance ? `+-${item.tolerance}` : '' }}
            </template>
        </v-data-table>
    </div>
</template>
<script>
export default {
    props: {
        headers: {
            type: Array,
            required: true,
            default: () => [],
        },
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
        tableTitle: {
            type: String,
            required: true,
            default: '',
        },
        tableSubTitle: {
            type: String,
            required: true,
            default: '',
        },
        isPassed: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    methods: {
        itemRowBackground(item) {
            return `notification new ${item.isPassed ? 'color-green' : 'color-red'}`;
        },
    },
};
</script>
